<template>
  <v-layout row justify-end>
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('AdministrationUnlockUserDialog.titleMsg') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="clearForm()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-form v-model="valid" ref="form" lazy-validation style="width: 100%">
          <v-card-text>
            <v-layout pa-5>
              <v-flex xs12>
                <v-subheader style="padding: 0px; font-size: 20px">{{ $t('AdministrationUnlockUserDialog.textMsg') }}</v-subheader>
                <v-radio-group v-model="wayOfUnlock" row style="padding: 0px" :rules="[v => !!v || 'You must select one mode']">
                  <v-radio label="Only unlock user" value="withoutPassword"></v-radio>
                  <v-radio label="Unlock and reset password" value="withPassword"></v-radio>
                </v-radio-group>
                <v-flex v-if="wayOfUnlock == 'withPassword'">
                  <v-text-field label="New Password (optional)" v-model="password" :rules="passwordRules" type="password"></v-text-field>
                  <v-text-field label="Confirm Password" v-model="confirmPassword" :rules="comfirmRules" type="password"></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="submit()">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Confirm') }}
            </v-btn>
            <v-btn color="secondary" outline @click="clearForm()">{{ $t('Button.Close') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
        {{ snackMessage }}
        <v-btn dark flat @click.native="snackbar = false">{{ $t('Button.Close') }}</v-btn>
      </v-snackbar>
    </v-card>
  </v-layout>
</template>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialog: '',
        snackbar: '',
        snackColor: '',
        snackMessage: '',
        valid: true,
        wayOfUnlock: '',

        password: '',
        confirmPassword: '',

        passwordRules: [
          (v) => (!v || v.length >= 6 && this.wayOfUnlock == 'withPassword') || 'Passwords must contain at least 6 characters',
        ],
        comfirmRules: [
          (v) => this.password == v || 'Passwords do not match',
        ],
      }
    },
    mounted() {},
    computed: {

    },
    watch: {
      show() {
        this.dialog = true
      },
    },
    methods: {
      submit() {
        if (this.$refs.form.validate()) {
          console('log submit')
        }
      },
      clearForm() {
        this.$refs.form.reset()
        this.dialog = false
      },
    },
  }
</script>